import type { FaqItem, FaqLink } from './faq.vue';

// FAQ 辅助工具函数
// 用于生成富文本内容中的链接和强调样式

// 创建链接映射表
export function createLinkMap(links: FaqLink[]): Record<string, string> {
  return links.reduce(
    (map, link) => {
      map[link.key] = link.url;
      return map;
    },
    {} as Record<string, string>,
  );
}

// 生成链接 HTML 标签
export function getLink(
  linkMap: Record<string, string>,
  key: string,
  title: string,
  target = '_blank',
): string {
  return linkMap[key] ? `<a href="${linkMap[key]}" target="${target}">${title}</a>` : title;
}

// 生成强调文本 HTML 标签
export function getStrong(text: string): string {
  return `<strong>${text}</strong>`;
}

// 生成联系方式链接
export function getContactLink(action: string, title: string): string {
  return `<a href="javascript:void(0)"  data-action="${action}" >${title}</a>`;
}

// 批量处理 FAQ 数据，添加 isOpen 状态
export function processFaqList(faqList: Omit<FaqItem, 'isOpen'>[], defaultOpen = false): FaqItem[] {
  return faqList.map(item => ({
    ...item,
    isOpen: defaultOpen,
  }));
}

// 创建 FAQ 辅助工具
export function useFaqHelper(links: FaqLink[]) {
  const linkMap = createLinkMap(links);

  return {
    // 生成链接
    getLink: (key: string, title: string, target?: string) => getLink(linkMap, key, title, target),
    // 生成强调文本
    getStrong,
    // 生成联系方式链接
    getContactLink,
    // 处理 FAQ 列表
    processFaqList,
  };
}
